import React from 'react';
import { FaUser } from 'react-icons/fa';

const Tech = ({ occupancy }) => {
  return (
      <div className="flex flex-col items-start gap-2 mx-auto  w-[340px] sm:w-[604px] md:w-[780px] lg:w-[800px] xl:w-[380px] 2xl:w-[380px] p-5 bg-white border border-[#E2E2E4] rounded-lg shadow-[0_1px_2px_0_#dedede]">
        <h2 className="text-sm sm:text-sm md:text-md lg:text-lg xl:text-lg 2xl:text-lg  font-bold text-gray-800">Main Library 3/F Technology Area</h2>
        <div className="flex items-center gap-4">
          <FaUser className="text-xl sm:text-xl md:text-2xl lg:text-3xl xl:text-3xl 2xl:text-3xl text-[#f39c12]" />
          <p className="text-2xl sm:text-xl md:text-2xl lg:text-3xl xl:text-3xl 2xl:text-3xl font-extrabold text-[#f39c12]">
            {occupancy || occupancy === 0 ? occupancy : 'N/A'}
          </p>
        </div>
      </div>
    );
};

export default Tech;
